import * as IconPack from 'react-icons/ti'

export default () => {
    const { ...exportIcons } = IconPack
    return exportIcons
}